var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#183558",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1 6a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#183558",
  strokeWidth: 2,
  d: "m1 19 13.735-9.312a2 2 0 0 1 2.089-.096L23 13"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 9,
  r: 1,
  stroke: "#183558",
  strokeWidth: 2
})));
export default SvgPhoto;